export default __webpack_public_path__ + "static/media/star.0d61a739.svg";